import { IntakeCoordinatorsMultiSelect } from "@/portals/(shared)/(profile)/components/IntakeCoordinatorsMultiSelect";
import { MultiSelectSkeleton } from "@/components/UI2/molecules/MultiSelect";
import { ProviderProfileForm } from "@/portals/(shared)/(profile)/components/ProviderProfileForm";
import type { UUID } from "@/core/types";

import { adaptIntakePracticeOptions } from "../helpers/adapters";
import { usePracticeList } from "../api/queries/usePracticeList";

type ProviderDetailsFormProps = {
  providerId: UUID;
};

export function ProviderDetailsForm({ providerId }: ProviderDetailsFormProps) {
  const { data: intakePracticeOptions = [], isLoading } = usePracticeList({
    select: adaptIntakePracticeOptions,
  });

  return (
    <ProviderProfileForm
      providerId={providerId}
      renderExtraField={({ control, isReadOnly, providerType }) => {
        if (providerType !== "BEHAVIORAL_INTAKE") return null;
        if (isLoading) return <MultiSelectSkeleton />;

        return (
          <IntakeCoordinatorsMultiSelect
            control={control}
            isReadOnly={isReadOnly}
            options={intakePracticeOptions}
          />
        );
      }}
      title="Provider Details"
    />
  );
}
